import { NgModule } from '@angular/core'
import { InputSelectService } from './input-select.service'
import { CommonModule } from '@angular/common'
import { InputSelectComponent } from './input-select.component';
import { BrowserModule } from '@angular/platform-browser';
import { ReactiveFormsModule } from '@angular/forms';
import { FilterPipe } from './input-select.pipe';

@NgModule(
    {
        declarations: [InputSelectComponent, FilterPipe],
        imports: [
            CommonModule,
            ReactiveFormsModule
        ],
        exports: [
            CommonModule,
            InputSelectComponent,
            FilterPipe
        ],
        providers: [
            InputSelectService
        ]
    }
)
export class InputSelectModule { }
